<template>
    <div>
      <v-data-table
        :headers="headers"
        :items="getAllItems"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top >
          <v-toolbar flat color="white" >
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar..."
            single-line
            hide-details
          ></v-text-field>
            <v-spacer></v-spacer>           
          </v-toolbar>
        </template>
        <template v-slot:[`item.fecha`]="{ item }">
          {{item.fecha | formatoFecha}}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon class="mr-2 mdi-24px" @click="printPDF(item)" color="blue">mdi-printer</v-icon>
          <v-icon class="mr-2 mdi-24px" @click="anularFactura(item)" color="red" :disabled="item.estado =='Anulada'">mdi-close-circle-outline</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Recargar</v-btn>
        </template>
      </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
import anularFel from '@/utils/anularFel'

export default {
     data: () => ({
      title:'DOCUMENTOS GENERADOS',
      search:'',
      headers: [       
        { text: 'Fecha', value: 'fecha' },
        { text: 'Cliente',align: 'left', value: 'cliente',},      
        { text: 'Serie',align: 'left', value: 'serie',width: '10%' },      
        { text: 'Numero',align: 'center', value: 'numero'},      
        { text: 'Autorización',align: 'center', value: 'autorizacion'},      
        { text: 'Tipo',align: 'center', value: 'tipo'},      
        { text: 'Descuento',align: 'center', value: 'descuento'},      
        { text: 'Total Factura',align: 'center', value: 'total'},      
        { text: 'Estado',align: 'center', value: 'estado',sortable: false, },
        { text: 'Opciones',align: 'center', value: 'actions', sortable: false },
      ],
      itemslist: [],
    }),

    async created () {
      await this.initialize()
    },
    computed: {
      getAllItems () {
        return this.$store.getters.getAllVentas
      },
      getTokenUser(){
      return this.$store.getters.getTokenUser
    }
    },
    methods: {
      async initialize () {
       await  this.$store.dispatch('setAllVentas')       
      }, 
      
       async anularFactura(item) {       
         Swal.fire({
          title: 'ANULAR FACTURA',
          text:'Escriba el motivo de la anulación',
          input: 'text',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, Anular!',
          cancelButtonText: 'Cancelar!'
        }).then((result) => {
          if (result.isConfirmed) {   
           const emisor = this.$store.getters.getEstablecimiento 
           const xmlAnularFel = anularFel(emisor.nit,item,result.value)

           this.anularDTE(xmlAnularFel,item.idfactura)  
          }
        })
                 
      },
      anularDTE(xmlAnularFel,idfactura){
        axios.post(`${this.$store.getters.getUrlProd}/fel/felSAT.php?op=anularFel`,{'xmlfel':xmlAnularFel}).then(res=>{
          
              if(res.data.Codigo==1){
                this.putFactura(idfactura);
              }else{
                this.errorSwal(res.data.Mensaje);
              }
        }).catch((err)=>{this.errorSwal('No pudo Anularse la factura'),console.log(err)})
      },
      async putFactura(idfactura){
        await axios.put(`${this.$store.getters.getUrlApi}/facturas/anular/${parseInt(idfactura)}`,{},this.getTokenUser).then(()=>{      
              this.alertDone('Factura Anulada')
              this.initialize()          
        }).catch(()=>{this.errorSwal('Error al anular la factura') })
      },         
      printPDF(item){
        this.$store.dispatch('printDocument',item.idfactura);
      },
      //Notificaciones Swal
      alertDone(message){
        Swal.fire({
          icon: 'success',
          title: message,
          showConfirmButton: false,
          timer: 1500
        })
      },
      errorSwal(message){
        Swal.fire({
          icon: 'error',
          title: message,        
        })
      }
    },

  filters: {
    formatoFecha: function (value) {
      if (!value) return ''
      return moment(value).format('DD/MM/YYYY')
    }
  }
    
}
</script>
